import React from 'react'

import BigOccupationItem from './BigOccupationItem'
import ModalList from '../modal/ModalList'
import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/type'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategories: BigCategory[]
  mappedSmallCategories: Record<string, SmallCategory[]>
}

const BigOccupationList = (props: PropsType) => {
  const { selectedJobIds, changeJobIds, bigCategories, mappedSmallCategories } = props
  const Items = bigCategories.map((bigCategory) => {
    const smallCategories = mappedSmallCategories[bigCategory.attributes.code]

    return (
      <BigOccupationItem
        key={bigCategory.id}
        bigCategory={bigCategory}
        smallCategories={smallCategories}
        selectedJobIds={selectedJobIds}
        changeJobIds={changeJobIds}
      />
    )
  })

  return <ModalList>{Items}</ModalList>
}

export default BigOccupationList
